import styled from "@emotion/styled";
import { ChangeEvent, FC } from "react";
import { FieldInputProps } from "react-final-form";

import { Info } from "@livechat/design-system-icons";
import { Checkbox, Icon, SpacingToken, Tooltip } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import {
  IRuleActionMessage,
  IRuleActionSendFollowUp,
  IRuleActionSendRatingRequest,
} from "store/entities/rules/interfaces";
import { withVar } from "themes/helpers";

import { changeActionValues } from "../utils";

type MessageBasedAction = IRuleActionMessage | IRuleActionSendRatingRequest | IRuleActionSendFollowUp;

interface IProps {
  input: FieldInputProps<MessageBasedAction>;
}

export const SkipPeopleInTheLoopCheckbox: FC<IProps> = ({ input }) => {
  const { value } = input;
  const isApplicable = value.type === "sendFollowUp" || (value.type === "message" && !value.isPrivate);

  if (!isApplicable) {
    return null;
  }

  // "PitL" is an abbreviation for "people in the loop", which refers to ticket CC recipients.
  const skipPitL = "skipPitL" in value ? value.skipPitL : undefined;

  const onChange = (event: ChangeEvent<HTMLInputElement>): void => {
    changeActionValues(input, { skipPitL: event.target.checked });
  };

  return (
    <Flex alignItems="center" gap={withVar(SpacingToken.Spacing1)}>
      <HighContrastCheckbox
        id="action-skip-pitl"
        checked={Boolean(skipPitL)}
        onChange={onChange}
        data-testid="action-skip-pitl"
      >
        Exclude other recipients
      </HighContrastCheckbox>
      <Tooltip kind="invert" triggerRenderer={<Icon source={Info} size="small" />}>
        Skip this message for people in the loop<br /> (ticket CC recipients)
      </Tooltip>
    </Flex>
  );
};


const HighContrastCheckbox = styled(Checkbox)`
  --action-primary-default: var(--action-high-contrast-default);
  --action-primary-hover: var(--action-high-contrast-hover);
  --action-primary-disabled: var(--action-high-contrast-disabled);
`;
